var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Field, ObjectType } from "type-graphql";
import { DateTimeScalar } from "../scalars/DateTimeISO.js";
import { isGlobalId } from "../scalars/GlobalId.js";
let Resource = class Resource {
    /**
     * This method should return a unique identifier for the instance.
     * This is usually a UUID, but should never be the numeric ID of
     * the instance in the database (that should remain internal)
     *
     * WARNING: This method is not implemented by all resources. If you
     * need to use this method, make sure the resource you are using
     * implements it.
     */
    getUniqueId() {
        if ("id" in this) {
            if (isGlobalId(this.id)) {
                return this.id.id;
            }
            else if (typeof this.id === "string") {
                return this.id;
            }
        }
        throw new Error(`Method not implemented by subclass.`);
    }
    static createInstance() {
        return new this();
    }
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-parameters
    withValues(values) {
        Object.assign(this, values);
        this.id = { id: values.id, typename: this.constructor.name };
        return this;
    }
};
Resource = __decorate([
    ObjectType()
], Resource);
export { Resource };
let TimestampedResource = class TimestampedResource extends Resource {
    createdAt;
    updatedAt;
};
__decorate([
    Field(() => DateTimeScalar, { nullable: true }),
    __metadata("design:type", Function)
], TimestampedResource.prototype, "createdAt", void 0);
__decorate([
    Field(() => DateTimeScalar, { nullable: true }),
    __metadata("design:type", Function)
], TimestampedResource.prototype, "updatedAt", void 0);
TimestampedResource = __decorate([
    ObjectType()
], TimestampedResource);
export { TimestampedResource };
//# sourceMappingURL=Resource.js.map